// ** Icons Import
import Dashboard from "../../assets/myIcons/dashboard.png";
import History from "../../assets/myIcons/file (1).png";
import Support from '../../assets/myIcons/customer-support.png';
import Billing from "../../assets/myIcons/invoice.png";
import DevIcon from "../../assets/myIcons/key.png";
import BulkUpload from "../../assets/myIcons/bulk_upload.png";

// const role = getUserRole()

const navIcon = (source) => (
  <img src={source} style={{ width: "20px", height: "20px" }} alt={''}/>
)

let dashboard = [

  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: navIcon(Dashboard),
    navLink: '/dashboard',
  },
  {
    id: 'history',
    title: 'History',
    icon: navIcon(History),
    navLink: '/history',
  },
  {
    id: 'batch-upload',
    title: 'Batch Upload',
    icon: navIcon(BulkUpload),
    navLink: '/batch-upload',
  },
  {
    id: 'apis',
    title: 'APIs',
    icon: navIcon(DevIcon),
    navLink: '/apis',
  },
  {
    id: 'support',
    title: 'Support',
    icon: navIcon(Support),
    navLink: '/support',
  },
  {
    id: 'audit-report',
    title: 'Billing & Usage',
    icon: navIcon(Billing),
    navLink: '/billing',
  },
]

export default dashboard;
